import React from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ProjectCards } from "src/widgets/ProjectCards";
import { RoutePaths } from "src/app/model";
import { AcceleratorCards } from "src/widgets/AcceleratorCards";

export const ProjectsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack
      id={RoutePaths.PROJECTS}
      width={1}
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={1}
      sx={{
        scrollMarginTop: 80,
      }}
    >
      <Typography
        color="text.secondary"
        variant="h5"
        component="h2"
        fontWeight="light"
        textTransform="uppercase"
        sx={{
          fontSize: { sm: "1.5rem", xs: "1rem" },
        }}
      >
        {t("projects.eyebrow")}
      </Typography>

      <Typography
        variant="h4"
        component="h3"
        fontWeight={300}
        marginBottom={2}
        color="text.secondary"
        sx={{
          fontSize: {
            lg: "2.125rem",
            md: "2rem",
            sm: "1.5rem",
            xs: "1.2rem",
          },
        }}
      >
        {t("projects.titleA")}{" "}
        <Typography
          component="span"
          color="primary"
          variant="inherit"
          fontWeight="inherit"
        >
          {t("projects.titleAccentAI")}{" "}
        </Typography>
        {t("projects.titleB")}{" "}
        <Typography
          component="span"
          color="primary"
          variant="inherit"
          fontWeight="inherit"
        >
          {t("projects.titleAccentLeaders")}
        </Typography>
      </Typography>

      <ProjectCards />

      <Typography
        variant="h4"
        component="h3"
        marginTop={4}
        fontWeight={300}
        color="text.secondary"
        textTransform="uppercase"
        sx={{
          fontSize: {
            lg: "2.125rem",
            md: "2rem",
            sm: "1.5rem",
            xs: "1.2rem",
          },
        }}
      >
        {t("projects.acceleratorsTitlePre")}{" "}
        <Typography
          component="span"
          color="primary"
          variant="inherit"
          fontWeight="inherit"
        >
          {t("projects.acceleratorsTitleAccent")}
        </Typography>
      </Typography>

      <Typography
        variant="h5"
        component="p"
        color="text.secondary"
        marginBottom={4}
        fontWeight={300}
        sx={{
          fontSize: { sm: "1.5rem", xs: "1rem" },
        }}
      >
        {t("projects.subEmphasizing")}{" "}
        <Typography
          component="span"
          color="primary"
          variant="inherit"
          fontWeight="inherit"
        >
          {t("projects.subAccentSpeed")}{" "}
        </Typography>
        {t("projects.subAmp")}{" "}
        <Typography
          component="span"
          color="primary"
          variant="inherit"
          fontWeight="inherit"
        >
          {t("projects.subAccentAcceleration")}
        </Typography>
      </Typography>

      <AcceleratorCards />
    </Stack>
  );
};
